import AccountTreeOutlined from "@mui/icons-material/AccountTreeOutlined";
import AutoAwesomeOutlined from "@mui/icons-material/AutoAwesomeOutlined";
import BlurOn from "@mui/icons-material/BlurOn";
import TableChart from "@mui/icons-material/TableChart";
import type { Components, Theme } from "@mui/material/styles";

export const MuiAlert: Components<Theme>["MuiAlert"] = {
  defaultProps: {
    iconMapping: {
      candidate: <AutoAwesomeOutlined fontSize="inherit" />,
      data: <TableChart fontSize="inherit" />,
      "search-space": <BlurOn fontSize="inherit" />,
      predictor: <AccountTreeOutlined fontSize="inherit" />,
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      variants: Object.entries(theme.palette)
        .filter(
          ([, values]) =>
            typeof values === "object" && "light" in values && "A700" in values
        )
        .map(([color, values]) => ({
          props: {
            colorSeverity: color,
            variant: "standard",
          },
          style: {
            backgroundColor: values.light,
            color: values.A700,
          },
        })),
    }),
  },
};
